import { colors } from "../../constants/colors";

const styles = {
  widgetContainer: {
    position: "fixed",
    bottom: 20,
    right: 20,
    zIndex: 1000,
  },
  collapsedWidget: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 50,
    height: 50,
    borderRadius: "50%",
    backgroundColor: colors.prussian_blue.DEFAULT,
    color: "white",
    cursor: "pointer",
    boxShadow: 3,
    "&:hover": {
      backgroundColor: colors.blue_green.DEFAULT,
    },
  },
  expandedWidget: {
    width: 350,
    maxWidth: "90vw",
    maxHeight: "80vh",
    p: 2,
    borderRadius: 2,
    boxShadow: 3,
    overflowY: "auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  submitButton: {
    mt: 2,
  },
  ratingContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  feedbackTypeContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  commentField: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "primary.main",
      },
      "&.Mui-focused fieldset": {
        borderColor: "primary.main",
      },
    },
  },
};

export { styles };
